// Footer Component with social links
export const Footer = () => (
  <footer style={{ padding: '20px', textAlign: 'center', backgroundColor: '#0A3D62', color: '#F5F5F5', marginTop: '20px' }}>
    <p>&copy; {new Date().getFullYear()} C-Encode | All Rights Reserved</p>
    <p style={{ fontSize: '0.9rem' }}>
      <a href="#top" style={{ color: '#FF6B35', textDecoration: 'none' }}>Back to Top</a>
    </p>
  </footer>
);